import { Box, Chip, Paper, Tooltip, Typography, Select, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { store } from '../redux/store/index';
import * as patientActions from '../redux/actions/patientActions';
import { useSelector } from "react-redux";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import BasicModal from "../components/Modal";
import { socket } from "../socket/socket";
import { API } from "../api/api";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import SyncIcon from '@mui/icons-material/Sync';
import Divider from '@mui/material/Divider';

const chipStyle = {
    backgroundColor: 'transparent',
    color: "#000000",
    fontSize: { xs: "12px", xl: "14px", lg: '14px', md: '12px' },
    border: "1px solid #E6E8EC"
};
const boxStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    overflowY: "auto",
    height: { xs: "auto", sm: "auto", md: '18vh', lg: '22vh', xl: '18vh', maxHeight: '22vh' },
    maxHeight: { xs: 80, md: '22vh' },
    flexDirection: "row",
    alignContent: "flex-start",
    py: 1,
}

const paperStyle = {
    // backdropFilter: "blur(10px)",
    // WebkitBackdropFilter: "blur(10px)",
    // backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: 4,
    border: "1px solid #E6E8EC",
    width: { xs: "100%", md: "195px", lg: "229px", xl: '215px' },
    textAlign: "center",
    boxSizing: 'border-box',
    boxShadow: 'none'
};

const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "stretch", md: "center" },
    gap: { xs: 1.25, md: 2 },
    px: { xs: 1, md: 0.4 },
    pb: { xs: 2, md: 3 },
    width: '100%',
    boxSizing: 'border-box',
};

const PatientInfo = () => {
    const { patientId, consultationId } = useParams();
    const patientReducer = useSelector(state => state.patientReducer);
    const [openParentModal, setOpenParentmodal] = useState(false)
    const [openRiskModal, setOpenRiskmodal] = useState(false)
    const [ongoingRisk, setOngoingRisk] = useState([])
    const [ongoingComplaint, setOngoingComplaint] = useState([])
    const location = useLocation();
    const [edit, setEdit] = useState(true)
    const conditions = patientReducer?.patientInfo?.conditions || []
    const [openConditionDialog, setOpenConditionDialog] = useState(false);
    const [selectedConditionIds, setSelectedConditionIds] = useState([]);
    const [allConditions, setAllConditions] = useState([]);
    const patientType = patientReducer?.patientInfo?.patientType || 'OBSTETRIC'

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const mode = queryParams.get('mode');
        if (mode) {
            setEdit(mode == "view" ? false : true);
        }
    }, [location.search]);

    useEffect(() => {
        if (patientId) {
            // store.dispatch(patientActions.getConditionRequestAction());
            // store.dispatch(patientActions.getPatientComplaintsRequestAction(patientId, "ONGOING"))
            store.dispatch(patientActions.getPatientRisksRequestAction(patientId, "ONGOING"))
        }
    }, [patientId])

    useEffect(() => {
        if (patientReducer?.complaintsWithCondition?.length > 0) {
            setAllConditions(patientReducer.complaintsWithCondition)
        }
    }, [patientReducer.complaintsWithCondition])

    const handleOpenConditionDialog = () => {
        const selected =
            patientReducer?.patientInfo?.conditions?.map(i => i.id) || [];

        setSelectedConditionIds(selected);
        setOpenConditionDialog(true);
    };

    useEffect(() => {
        if (!patientId) return;
        const handleCommandOutput = (data) => {
            console.log("data came on event", data)
            const [, , rawCardType] = data?.data?.originActionType?.split('.');

            let cardType = rawCardType;
            let cardKey = rawCardType;
            if (rawCardType.includes(':')) {
                const [cardCategory, id] = rawCardType.split(':');
                cardType = cardCategory
                cardKey = rawCardType
            }
            if (consultationId !== data?.data?.consultationId) {
                return
            }
            if (
                data?.actionType === "commandOutput.refreshWebDashboard"
            ) {
                if (cardType == "activeSymptoms") {
                    store.dispatch(patientActions.getPatientComplaintsRequestAction(patientId, "ONGOING"))
                }
                if (cardType == "risks" || cardType == "condition"|| cardType == "conditions") {
                    store.dispatch(patientActions.getPatientRisksRequestAction(patientId, "ONGOING"))
                }
            }
        };
        socket.on("commandOutput", handleCommandOutput);
    }, [patientId]);


    useEffect(() => {
        const ongoing = [
            ...(patientReducer?.ongoingComplaints || []),
        ];
        setOngoingComplaint(ongoing);
    }, [
        patientReducer?.ongoingComplaints,
    ]);

    useEffect(() => {
        const ongoing = [
            ...(patientReducer?.ongoingRisks || [])
        ];
        setOngoingRisk(ongoing);
    }, [
        patientReducer?.ongoingRisks,
    ]);

    const patient = patientReducer?.patientInfo

    const handleConditionToggle = (id) => {
        setSelectedConditionIds(prev => {
            if (prev.includes(id)) {
                return prev.filter(x => x !== id);
            }
            return [...prev, id];
        });
    };

    const saveConditions = async () => {
        const existing =
            patientReducer?.patientInfo?.conditions || [];
        if (existing.length === 0) {
            store.dispatch(
                patientActions.createConditionRequestAction(
                    consultationId,
                    {
                        complaintIds: [],
                        conditionIds: selectedConditionIds,
                    }
                )
            );
            setOpenConditionDialog(false);
            return;
        }
        const previousIds =
            existing.map(x => x.id);
        const addConditionIds =
            selectedConditionIds.filter(
                id => !previousIds.includes(id)
            );
        const removePatientConditionIds =
            existing
                .filter(
                    item =>
                        !selectedConditionIds.includes(item.id)
                )
                .map(
                    item => item.patientConditionId
                );

        await API.patch(
            `/v1/consultations/${consultationId}/conditions`,
            {
                addConditionIds,
                removePatientConditionIds,
            }
        );
        setOpenConditionDialog(false);
        store.dispatch(
            patientActions.getPatientDetailsRequestAction(patientId)
        );
    }

    const isConfirmed = (conditionId) =>
        conditions.some(
            item => item.id === conditionId && item.isConfirmed
        );

    const isExisting = (conditionId) =>
        conditions.some(item => item.id === conditionId);

    const getRiskWeight = (item) => {
        if (item?.weight !== undefined && item?.weight !== null && !isNaN(Number(item.weight))) {
            return Number(item.weight);
        }
        if (item?.remarks) {
            const match = item.remarks.match(/\(\+?(\d+)\s*(?:pts?|points?|score)?\)/i);
            if (match) return parseInt(match[1], 10);
            const match2 = item.remarks.match(/\[weight:\s*(\d+)\]/i);
            if (match2) return parseInt(match2[1], 10);
        }
        const title = (item?.title || "").toLowerCase();
        if (
            title.includes("pe/htn") ||
            title.includes("pre-eclampsia") ||
            title.includes("preeclampsia") ||
            title.includes("vte") ||
            title.includes("thrombosis") ||
            title.includes("gdm") ||
            title.includes("diabetes") ||
            title.includes("prev cs") ||
            title.includes("caesarean") ||
            title.includes("placenta") ||
            title.includes("aph") ||
            title.includes("pprom") ||
            title.includes("prom") ||
            title.includes("preterm birth")
        ) {
            return 4;
        }
        if (
            title.includes("obesity") ||
            title.includes("bmi") ||
            title.includes("anaemia") ||
            title.includes("anemia") ||
            title.includes("chronic hypertension") ||
            title.includes("multiple pregnancy") ||
            title.includes("rpl") ||
            title.includes("recurrent") ||
            title.includes("fibroid") ||
            title.includes("thyroid") ||
            title.includes("family")
        ) {
            return 2;
        }
        return 1;
    };

    const getTierFromScore = (score) => {
        if (score > 7) return "HIGH";
        if (score >= 4) return "MEDIUM";
        return "LOW";
    };

    const getSeverityTheme = (tierOrScore) => {
        let tier = "LOW";
        if (typeof tierOrScore === "number") {
            tier = getTierFromScore(tierOrScore);
        } else if (typeof tierOrScore === "string") {
            tier = tierOrScore.toUpperCase();
        }

        if (tier === "HIGH") return { tier: "HIGH", label: "High Risk", shortLabel: "High", bg: "#FEE2E2", text: "#991B1B", border: "#F87171" };
        if (tier === "MEDIUM") return { tier: "MEDIUM", label: "Medium Risk", shortLabel: "Medium", bg: "#FEF3C7", text: "#92400E", border: "#FBBF24" };
        return { tier: "LOW", label: "Low Risk", shortLabel: "Low", bg: "#D1FAE5", text: "#065F46", border: "#34D399" };
    };

    const unconfirmedRisks = ongoingRisk.filter(r => !r.isConfirmed);
    const confirmedRisks = ongoingRisk.filter(r => r.isConfirmed);

    const confirmedScore = confirmedRisks.reduce((sum, r) => sum + getRiskWeight(r), 0);
    const unconfirmedScore = unconfirmedRisks.reduce((sum, r) => sum + getRiskWeight(r), 0);
    const projectedScore = confirmedScore + unconfirmedScore;

    const savedTier = localStorage.getItem(`patient_confirmed_tier_${patientId}`) || patientReducer?.patientInfo?.riskLevel;
    const [confirmedTier, setConfirmedTier] = useState(savedTier ? savedTier.toUpperCase() : "LOW");

    useEffect(() => {
        if (patientReducer?.patientInfo?.riskLevel) {
            setConfirmedTier(patientReducer.patientInfo.riskLevel.toUpperCase());
        }
    }, [patientReducer?.patientInfo?.riskLevel]);

    const tierRank = { LOW: 1, MEDIUM: 2, HIGH: 3 };
    const targetTier = getTierFromScore(projectedScore);

    // Escalation stays active if target tier is higher than the acknowledged tier, OR unconfirmed risks push tier higher
    const isEscalating = tierRank[targetTier] > tierRank[confirmedTier] || (unconfirmedRisks.length > 0 && targetTier !== 'LOW');

    const currentSeverity = getSeverityTheme(confirmedTier);
    const projectedSeverity = getSeverityTheme(targetTier);

    const confirmRisks = async (specificRiskId = null) => {
        const unconfirmedRiskIds = specificRiskId
            ? [specificRiskId]
            : ongoingRisk.filter(r => !r.isConfirmed).map(r => r.id);

        if (!unconfirmedRiskIds.length) return;

        await API.post(`/v1/patients/${patientId}/risks/confirm`, {
            riskIds: unconfirmedRiskIds,
        });

        // Refresh ongoing risks
        store.dispatch(
            patientActions.getPatientRisksRequestAction(patientId, "ONGOING")
        );
        store.dispatch(
            patientActions.getPatientEndedRisksRequestAction(patientId, "ENDED")
        );
    };

    const confirmEscalation = async () => {
        // 1. Confirm any pending risks
        const unconfirmedRiskIds = ongoingRisk.filter(r => !r.isConfirmed).map(r => r.id);
        if (unconfirmedRiskIds.length > 0) {
            await API.post(`/v1/patients/${patientId}/risks/confirm`, {
                riskIds: unconfirmedRiskIds,
            });
            store.dispatch(
                patientActions.getPatientRisksRequestAction(patientId, "ONGOING")
            );
            store.dispatch(
                patientActions.getPatientEndedRisksRequestAction(patientId, "ENDED")
            );
        }

        // 2. Persist escalated tier
        try {
            await API.patch(`/v1/patients/${patientId}`, {
                riskLevel: targetTier,
            });
        } catch (err) {
            console.error("Error updating patient riskLevel", err);
        }
        localStorage.setItem(`patient_confirmed_tier_${patientId}`, targetTier);
        setConfirmedTier(targetTier);
        store.dispatch(patientActions.getPatientDetailsRequestAction(patientId, true));
    };

    return (
        <Box sx={containerStyle}>
            <Paper
                elevation={3}
                sx={{ ...paperStyle, px: 1, py: 0.8, minHeight: { xs: 70, md: 'auto' } }}
            >
                {/* Card Header: Title, Current Risk Badge & Expand Icon */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                        <Typography textAlign={'left'} fontSize={'14px'} sx={{ fontWeight: '700' }}>
                            Risk
                        </Typography>
                        <Chip
                            label={`${currentSeverity.label} (${confirmedScore})`}
                            size="small"
                            sx={{
                                height: '20px',
                                fontSize: '10px',
                                fontWeight: 700,
                                bgcolor: currentSeverity.bg,
                                color: currentSeverity.text,
                                border: `1px solid ${currentSeverity.border}`,
                                px: 0.2,
                            }}
                        />
                    </Box>
                    {(patient?.currentWeek || patientType == "GYNECOLOGY") && (
                        <OpenInFullIcon
                            onClick={() => setOpenRiskmodal(!openRiskModal)}
                            sx={{ cursor: 'pointer', fontSize: '16px', flexShrink: 0, color: '#6B7280' }}
                        />
                    )}
                </Box>

                {/* ---------------- Risk Escalation Indicator (Low -> Medium) with Confirm Button ---------------- */}
                {isEscalating && (
                    <Box
                        sx={{
                            mt: 0.8,
                            mb: 1,
                            p: 1,
                            borderRadius: 1.5,
                            bgcolor: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.6,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                                Potential Escalation
                            </Typography>
                            <Chip
                                label={`+${projectedScore - (confirmedTier === 'LOW' && tierRank[targetTier] > 1 ? (confirmedScore > 0 && confirmedTier === targetTier ? 0 : projectedScore) : unconfirmedScore)} pts`}
                                size="small"
                                sx={{
                                    height: '16px',
                                    fontSize: '9px',
                                    fontWeight: 700,
                                    bgcolor: '#E2E8F0',
                                    color: '#334155',
                                    px: 0.2,
                                }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5 }}>
                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#1E293B' }}>
                                {currentSeverity.shortLabel} ({confirmedScore}) &rarr; <span style={{ color: projectedSeverity.text }}>{projectedSeverity.shortLabel} ({projectedScore})</span>
                            </Typography>
                            {edit && (
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={confirmEscalation}
                                    sx={{
                                        fontSize: '9.5px',
                                        py: 0.2,
                                        px: 1,
                                        minHeight: '22px',
                                        bgcolor: '#2563EB',
                                        '&:hover': { bgcolor: '#1D4ED8' },
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderRadius: 1.5,
                                        boxShadow: 'none',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    Confirm
                                </Button>
                            )}
                        </Box>
                    </Box>
                )}

                {/* ---------------- 2 Columns: Risk & Weights ---------------- */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 1,
                        py: 0.4,
                        bgcolor: '#F3F4F6',
                        borderRadius: 1,
                        mt: 0.5,
                        mb: 0.5,
                    }}
                >
                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#4B5563', textTransform: 'uppercase' }}>
                        Risk
                    </Typography>
                    <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#4B5563', textTransform: 'uppercase' }}>
                        Weights
                    </Typography>
                </Box>

                <Box
                    sx={{
                        maxHeight: 220,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0.5,
                        mb: 0.5,
                    }}
                >
                    {ongoingRisk.length === 0 ? (
                        <Typography sx={{ mt: 1, mb: 1, color: '#999', fontSize: '11px' }}>
                            No risks found.
                        </Typography>
                    ) : (
                        ongoingRisk.map((risk) => {
                            const weight = getRiskWeight(risk);
                            const isPending = !risk.isConfirmed;

                            return (
                                <Box
                                    key={risk.id}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        px: 0.8,
                                        py: 0.5,
                                        borderRadius: 1,
                                        bgcolor: '#F9FAFB',
                                        border: '1px solid #E5E7EB',
                                        gap: 0.5,
                                    }}
                                >
                                    {/* Risk Column */}
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, minWidth: 0, textAlign: 'left' }}>
                                        <Tooltip
                                            title={
                                                <>
                                                    <strong>{risk.title} (+{weight} pts)</strong>
                                                    {risk.remarks && (
                                                        <>
                                                             <br />
                                                             Remarks: {risk.remarks}
                                                         </>
                                                    )}
                                                    {isPending && (
                                                        <>
                                                             <br />
                                                             <em>Pending review</em>
                                                         </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <Typography
                                                noWrap
                                                sx={{
                                                    fontSize: '11px',
                                                    fontWeight: 600,
                                                    color: '#1F2937',
                                                    maxWidth: '100%',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {risk.title}
                                            </Typography>
                                        </Tooltip>

                                        {isPending && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.2 }}>
                                                <Typography sx={{ fontSize: '9px', color: '#6B7280', fontWeight: 600 }}>
                                                    Pending
                                                </Typography>
                                                {edit && (
                                                    <Button
                                                        size="small"
                                                        onClick={() => confirmRisks(risk.id)}
                                                        sx={{
                                                            fontSize: '8.5px',
                                                            py: 0,
                                                            px: 0.6,
                                                            minHeight: '16px',
                                                            bgcolor: '#2563EB',
                                                            color: '#FFFFFF',
                                                            '&:hover': { bgcolor: '#1D4ED8' },
                                                            textTransform: 'none',
                                                            fontWeight: 600,
                                                            borderRadius: 1,
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        Confirm
                                                    </Button>
                                                )}
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Weights Column */}
                                    {edit ? (
                                        <Select
                                            size="small"
                                            value={weight}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                const newWeight = Number(e.target.value);
                                                store.dispatch(patientActions.updateRiskRequestAction(patientId, risk.id, { weight: newWeight }));
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                            sx={{
                                                height: '20px',
                                                fontSize: '10px',
                                                fontWeight: 700,
                                                bgcolor: '#F3F4F6',
                                                color: '#374151',
                                                borderRadius: '6px',
                                                '.MuiSelect-select': { py: '0px !important', px: '4px !important', pr: '16px !important' },
                                                '.MuiSvgIcon-root': { fontSize: '13px', right: '0px' },
                                                border: 'none',
                                                '& fieldset': { border: 'none' },
                                                flexShrink: 0,
                                            }}
                                        >
                                            <MenuItem value={1} sx={{ fontSize: '11px', py: 0.5 }}>+1 pt</MenuItem>
                                            <MenuItem value={2} sx={{ fontSize: '11px', py: 0.5 }}>+2 pts</MenuItem>
                                            <MenuItem value={3} sx={{ fontSize: '11px', py: 0.5 }}>+3 pts</MenuItem>
                                            <MenuItem value={4} sx={{ fontSize: '11px', py: 0.5 }}>+4 pts</MenuItem>
                                            <MenuItem value={5} sx={{ fontSize: '11px', py: 0.5 }}>+5 pts</MenuItem>
                                        </Select>
                                    ) : (
                                        <Chip
                                            label={`+${weight}`}
                                            size="small"
                                            sx={{
                                                height: '18px',
                                                fontSize: '10px',
                                                fontWeight: 700,
                                                bgcolor: '#F3F4F6',
                                                color: '#374151',
                                                px: 0.2,
                                                flexShrink: 0,
                                            }}
                                        />
                                    )}
                                </Box>
                            );
                        })
                    )}
                </Box>

                {/* Confirm all pending risks if more than 1 pending */}
                {edit && unconfirmedRisks.length > 1 && (
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{
                            mt: 0.5,
                            mb: 0.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: '10px',
                            bgcolor: '#2563EB',
                            '&:hover': { bgcolor: '#1D4ED8' },
                            boxShadow: 'none',
                            py: 0.5,
                        }}
                        onClick={() => confirmRisks()}
                    >
                        Confirm All Pending ({unconfirmedRisks.length})
                    </Button>
                )}
            </Paper>

            {/* {conditions.length > 0 && <Button
                variant="outlined"
                size="small"
                sx={{ border: '1px dashed black', color: '#494949', textTransform: 'none', fontWeight: '600', }}
                onClick={handleOpenConditionDialog}
            >
                Reassess Conditions
            </Button>}

            {conditions.length > 0 &&
                <Box sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                }}>
                    {conditions?.map((item, i) => (
                        <Chip key={i} label={item.name} sx={{
                            ...chipStyle,
                            bgcolor:
                                item.isConfirmed
                                    ? "#E8F5E9"
                                    : "#FFF3E0",
                            color:
                                item.isConfirmed
                                    ? "#2E7D32"
                                    : "#ED6C02",
                            border: `1px solid ${item.isConfirmed
                                ? "#81C784"
                                : "#FFB74D"
                                }`,
                        }} />
                    ))}
                </Box>
            } */}

            {/* <Paper
                elevation={3}
                sx={{ ...paperStyle, px: 1, minHeight: { xs: 70, md: 'auto' } }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '5px', alignItems: 'center' }}>
                    <Typography textAlign={'center'} fontSize={'14px'} sx={{ flex: 1 }}>
                        Complaints
                    </Typography>
                    {
                        (patient?.currentWeek || patientType == "GYNECOLOGY") &&
                        <OpenInFullIcon onClick={() => setOpenParentmodal(!openParentModal)} sx={{ cursor: 'pointer', fontSize: '17px', flexShrink: 0 }} />}
                </Box>
                <Box sx={boxStyle}>
                    {ongoingComplaint?.map((item, i) => (
                        <Chip key={i} label={item.title} sx={chipStyle} />
                    ))}
                </Box>
            </Paper> */}
            <BasicModal open={openParentModal || openRiskModal} type={openParentModal ? "Complaints" : 'Risk'} handleCloseComplaint={() => setOpenParentmodal(!openParentModal)} handleCloseRisk={() => setOpenRiskmodal(!openRiskModal)} patientType={patientType} edit={edit}/>
            <Dialog
                open={openConditionDialog}
                onClose={() => setOpenConditionDialog(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                    },
                }}
            >
                <DialogTitle sx={{ alignContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <SyncIcon sx={{ color: 'green' }} />
                    Reassess Conditions
                </DialogTitle>

                <DialogContent>
                    <Divider />
                    <Typography sx={{ marginTop: '4px' }}>
                        Add or change the conditions under review. Existing records are kept — any newly added condition brings in its sections, highlighted as New.
                    </Typography>

                    <Box display="flex" flexWrap="wrap" gap={1} sx={{ mt: 2 }}>
                        {allConditions.map(condition => {
                            const existing = isExisting(condition.id);
                            const confirmed = isConfirmed(condition.id);
                            const selected = selectedConditionIds.includes(condition.id)
                            return (<Box
                                key={condition.id}
                                onClick={() => handleConditionToggle(condition.id)}
                                sx={{
                                    border: selected ? "2px solid grey" : "1px solid #D3D3D3",
                                    backgroundColor: selected ? "#FFFFFF" : 'transparent',
                                    borderRadius: 4,
                                    cursor: "pointer",
                                    p: 0.6,
                                    position: "relative",
                                    flexDirection: 'row', display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography sx={{
                                    fontSize: { xl: '14px', lg: '12px', md: '11px' },
                                }}>
                                    {condition.name}
                                </Typography>
                                {(existing && selected) && (
                                    <Chip
                                        size="small"
                                        label={confirmed ? "Confirmed" : "Unconfirmed"}
                                        sx={{
                                            height: 20,
                                            fontSize: 11,
                                            bgcolor: confirmed ? "#E8F5E9" : "#FFF3E0",
                                            color: confirmed ? "#2E7D32" : "#ED6C02",
                                            border: `1px solid ${confirmed ? "#81C784" : "#FFB74D"
                                                }`,
                                            marginLeft: '4px'
                                        }}
                                    />
                                )}
                            </Box>)
                        })}

                    </Box>
                    <Divider sx={{ marginTop: '10px' }} />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenConditionDialog(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={saveConditions}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default PatientInfo;
